import { render } from "./class-multiple.vue?vue&type=template&id=30c971fb"
import script from "./class-multiple.vue?vue&type=script&lang=js"
export * from "./class-multiple.vue?vue&type=script&lang=js"

import "./class-multiple.vue?vue&type=style&index=0&id=30c971fb&lang=css"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__